module.exports = __webpack_public_path__ + "static/media/checked.05d5cfa1.svg";